function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30.001,
    height: 30,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 30.001 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BG"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 30,
    height: 30,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ebene_11",
    "data-name": "Ebene_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M0,25V5.001h30L0,25Z",
    style: {
      fill: "#003580"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.001,5v19.999H0L30.001,5Z",
    style: {
      fill: "#009543"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "23.94 5 0 20.96 0 24.967 .023 25 5.958 25 30.001 8.971 30.001 5 23.94 5",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.001 5.025 29.984 5 25.544 5 0 22.027 0 25 4.555 25 30.001 8.038 30.001 5.025",
    style: {
      fill: "#d21034"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.001,7.114l.518,1.402,1.149-.955-.253,1.473,1.473-.253-.955,1.149,1.402.518-1.402.518.955,1.149-1.473-.253.253,1.473-1.149-.955-.518,1.402-.518-1.402-1.149.955.253-1.473-1.473.253.955-1.149-1.402-.518,1.402-.518-.955-1.149,1.473.253-.253-1.473,1.149.955.518-1.402Z",
    style: {
      fill: "#ffce00"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.001,12.447c-1.103,0-2.001-.897-2.001-2s.897-2,2.001-2,2.001.897,2.001,2c-.001,1.103-.899,2-2.001,2ZM6.001,8.781c-.919,0-1.667.748-1.667,1.667s.748,1.667,1.667,1.667,1.667-.748,1.667-1.667c-.001-.92-.748-1.667-1.667-1.667Z",
    style: {
      fill: "#003580"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNa);
export default __webpack_public_path__ + "static/media/NA.775e02f923cccaecab26bd59d4978e31.svg";
export { ForwardRef as ReactComponent };